import { render, staticRenderFns } from "./ImgList.vue?vue&type=template&id=be13cc8a&scoped=true"
import script from "./ImgList.vue?vue&type=script&lang=js"
export * from "./ImgList.vue?vue&type=script&lang=js"
import style0 from "./ImgList.vue?vue&type=style&index=0&id=be13cc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be13cc8a",
  null
  
)

export default component.exports